(function ($, window, undefined) {


    $("#box-parceiros .rep a.openrep").on("click", function () {
        $("#box-parceiros").addClass("activerep");
        $(".parceiros-page").addClass("onrep");
        return false;
    });

    $("#box-parceiros .closerep").on("click", function () {
        $("#box-parceiros").removeClass("activerep");
        $(".parceiros-page").removeClass("onrep");
        return false;
    });


    $(".outsourcing-links").on("click", function () {
        $(" #outs-box, #outsourcing").toggle();
        $(".parceiros-page").addClass("onout");
    });

    $("#outsourcing ul li a").on("click", function () {
        $("#outs-box > div").hide();
        $($(this).attr("href")).show();
        return false;
    });

    $(" #outs-box .closeouts").on("click", function () {
        $(" #outs-box, #outsourcing").hide();
        $(".parceiros-page").removeClass("onout");
    });

    $("#outs-box").niceScroll();

}(jQuery, window));
